/**
 * Fixed section-dial destinations (handoff 3 §3). Order must not be personalised.
 */
export const SECTION_DIAL_ORDER = [
  'clubs',
  'hunts',
  'ground',
  'community',
  'profile',
  'toolkit',
  'messages',
];

export const SECTION_DIAL_CARDS = {
  clubs: {
    id: 'clubs',
    title: 'Clubs',
    sub: 'ROSTERS · BOARD',
  },
  hunts: {
    id: 'hunts',
    title: 'Hunts',
    sub: 'YOUR LOG',
  },
  ground: {
    id: 'ground',
    title: 'My Ground',
    sub: 'YOUR MAP',
  },
  community: {
    id: 'community',
    title: 'Community',
    sub: 'BUDDIES · FIND',
  },
  profile: {
    id: 'profile',
    title: 'Profile',
    sub: 'ACCOUNT · STUFF',
  },
  toolkit: {
    id: 'toolkit',
    title: 'Toolkit',
    sub: 'FEED · PLANT',
  },
  messages: {
    id: 'messages',
    title: 'Messages',
    sub: 'INBOX',
  },
};

/**
 * Which dial card is active for the current page id from resolveCurrentPage.
 */
export function resolveActiveDialCardId(currentPage = '') {
  const page = String(currentPage || '');
  if (page === 'clubs') return 'clubs';
  if (page === 'hunts') return 'hunts';
  if (page === 'maps') return 'ground';
  if (
    page === 'hunting-buddies' ||
    page === 'find-club' ||
    page === 'find-processor' ||
    page === 'suggest-store' ||
    page === 'camp-essentials'
  ) {
    return 'community';
  }
  if (page === 'profile' || page === 'notifications') return 'profile';
  if (page === 'toolkit') return 'toolkit';
  if (page === 'messages') return 'messages';
  return null;
}
